import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowLeftIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M12.7599 25.0932C12.5066 25.0932 12.2533 24.9999 12.0533 24.7999L3.95992 16.7066C3.57326 16.3199 3.57326 15.6799 3.95992 15.2932L12.0533 7.19991C12.4399 6.81325 13.0799 6.81325 13.4666 7.19991C13.8533 7.58658 13.8533 8.22658 13.4666 8.61325L6.07992 15.9999L13.4666 23.3866C13.8533 23.7732 13.8533 24.4132 13.4666 24.7999C13.2799 24.9999 13.0133 25.0932 12.7599 25.0932Z",
      fill: _ctx.color || '#292E36'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M27.3333 17H4.89331C4.34664 17 3.89331 16.5467 3.89331 16C3.89331 15.4533 4.34664 15 4.89331 15H27.3333C27.88 15 28.3333 15.4533 28.3333 16C28.3333 16.5467 27.88 17 27.3333 17Z",
      fill: _ctx.color || '#292E36'
    }, null, 8, _hoisted_3)
  ]))
}
}

})